import { requireImgAssets } from '@/utils/utils'

const data = {
  internationalLogisticsService: ($pconf) => [
    {
      title: 'modules.home.intService', // 国际物流服务
      subTitle: 'modules.home.intTips', // 安全、高效、高品质的国际物流服务
      children: [
        {
          title: 'modules.home.courierService', // 快递服务
          // img: requireImgAssets('@/assets/img/home/product_01.png'),
          img: requireImgAssets('@/assets/img/home/product_bg_new_01.svg'),
          imgAlt: 'kuaidi',
          path: '/product',
          params: { query: { subProduct: 'express' } },
          img_bg: requireImgAssets('@/assets/img/home/product_bg_01.png'),
          img_bg2: requireImgAssets('@/assets/img/home/product_mb_new_01.svg'),
          // img_mb: requireImgAssets('@/assets/img/home/product_mb_01.png'),
          // img_mb: requireImgAssets('@/assets/img/home/product_mb_new_01.svg'),
          img_mb: requireImgAssets('@/assets/img/home/product_mb_cn_kr.png'),
          // img_mb: '@/assets/img/product_mb_new_01.svg',

          // img_mb: '~/assets/img/home/product_mb_new_01.svg',

          track: 'express_delivery_click|快递服务点击率',
          description:
            'modules.logisticsService.productList.expressDescription',
          children: [
            {
              title: 'modules.logisticsService.productList.fast', // 国际标快
              subTitle: 'modules.home.tip1', // 精准时效，通过各环节均有标准化流程保障，提供门到门的高品质快递服务
              path: '/product/fast',
              params: { query: { isProduct: 'product' } },
            },
            {
              title: 'modules.logisticsService.productList.discts', // 国际特惠
              subTitle: 'modules.home.tip2', // 为满足客户非紧急物品寄递需求而推出的经济型国际快件服务
              path: '/product/discts',
              params: { query: { isProduct: 'product' } },
            },
            {
              title: 'modules.home.more', // 了解更多
              isMore: true,
              img: '~/assets/img/arrow_right.png',
              path: '/product',
              params: { hash: 'product' },
            },
          ],
        },
        {
          title: 'modules.home.electService', // 电商服务
          // img: requireImgAssets('@/assets/img/home/product_02.png'),
          img: requireImgAssets('@/assets/img/home/product_bg_new_02.svg'),
          imgAlt: 'dianshang',
          path: '/product',
          params: { query: { subProduct: 'e-commerce' } },
          img_bg: requireImgAssets('@/assets/img/home/product_bg_02.png'),
          img_bg2: '~/assets/img/home/product_bg_02.png',
          // img_mb: requireImgAssets('@/assets/img/home/product_mb_02.png'),
          img_mb: requireImgAssets('@/assets/img/home/product_mb_new_02.svg'),

          // img_mb: '@/assets/img/home/product_mb_new_02.svg',
          track: 'ecommerce_service_click|电商服务点击率',
          description:
            'modules.logisticsService.productList.ecommerceDescription',
          children: [
            {
              title: 'modules.logisticsService.productList.delivery', // 国际电商专递
              subTitle: 'modules.home.tip3', // 专为跨境B2C电商卖家量身定制的高效物流服务
              path: '/product/delivery',
              params: { query: { isProduct: 'product' } },
            },
            {
              title: 'modules.logisticsService.productList.parcel', // 国际小包
              subTitle: 'modules.home.tip4', // 跨境电商B2C卖家发送2KG以下包裹的品质小包类服务
              path: '/product/parcel',
              params: { query: { isProduct: 'product' } },
            },
            {
              title: 'modules.logisticsService.productList.consolidation', // 国际集运
              subTitle: 'modules.logisticsService.productList.consolidationDescription', // 顺丰集团打造的海淘转运服务，致力于为您提供足不出户、购遍全球优质商品的物流体验。
              path: '/product/sfbuy',
              params: { query: { isProduct: 'product' } },
            },
            // {
            //   title: 'modules.logisticsService.productList.warehouse', // 海外仓
            //   subTitle: 'modules.home.tip5', // 提供一站式国际仓储物流解决方案
            //   path: '/product/warehouse',
            //   params: { query: { isProduct: 'product' } },
            // },
            {
              title: 'modules.home.more', // 了解更多
              isMore: true,
              img: '~/assets/img/arrow_right.png',
              path: '/product',
              params: { hash: 'product' },
            },
          ],
        },

        // 供应链服务
        {
          title: 'modules.logisticsService.productList.supplyChain', //
          // img: requireImgAssets('@/assets/img/home/product_02.png'),
          // img: requireImgAssets('@/assets/img/home/product_bg_new_02.svg'),
          img: requireImgAssets('@/assets/img/home/product_bg_new_03.png'),
          imgAlt: 'dianshang',
          path: '/product',
          params: { query: { subProduct: 'e-commerce' } },
          img_bg: requireImgAssets('@/assets/img/home/product_bg_02.png'),
          img_bg2: '~/assets/img/home/product_mb_new_03.png',
          // img_mb: requireImgAssets('@/assets/img/home/product_mb_02.png'),
          // img_mb: requireImgAssets('@/assets/img/home/product_mb_new_02.svg'),
          img_mb: requireImgAssets('@/assets/img/home/product_mb_new_03.png'),
          // img_mb: '@/assets/img/home/product_mb_new_03.png',
          track: 'ecommerce_service_click|电商服务点击率',
          description:
            'modules.logisticsService.productList.ecommerceDescription',
          children: [
            {
              title:
                'modules.logisticsService.productList.internationalWarehousingAndDistribution', // 国际仓储
              subTitle: 'modules.home.tip9', // 为跨境电商客户提供海外仓配等一站式物流解决方案
              path: '/product/internationalWarehousingAndDistribution',
              params: { query: { isProduct: 'product' } },
            },
            {
              title:
                'modules.logisticsService.productList.internationalAirTransport', // 国际空运
              subTitle: 'modules.home.tip10', // 依托自有全货机及外部市场航空资源，提供高效的空运解决方案，业务类型覆盖包机、包板、散销。
              path: '/product/internationalAirTransport',
              params: { query: { isProduct: 'product' } },
            },
            {
              title:
                'modules.logisticsService.productList.internationalTransport', // 国际运输
              subTitle: 'modules.home.tip11', // 顺丰整合国际海运/铁路/陆运资源，构建全航线、多式联运物流网络，为全球客户提供灵活高效的跨境运输解决方案。
              path: '/product/internationalTransport',
              params: { query: { isProduct: 'product' } },
            },
            {
              title: 'modules.logisticsService.productList.crossBorderFBA', // 跨境FBA
              subTitle: 'modules.home.tip12', // 为国际跨境电商卖家提供标准型头程送仓物流服务，支持FBA仓、沃尔玛仓、海外三方仓等。
              path: '/product/crossBorderFBA',
              params: { query: { isProduct: 'product' } },
            },
            {
              title: 'modules.home.more', // 了解更多
              isMore: true,
              img: '~/assets/img/arrow_right.png',
              path: '/product',
              params: { hash: 'product' },
            },
          ],
        },
      ],
    },
  ],
}

export default data
